import axios from "axios";
import AuthService from "../login/auth.service";
import { consultasAPI, solicitudes } from "../../components/generico/utils/UrlAPI";

export async function getTipoTarjeta() {
  var config = {
    method: "get",
    url: solicitudes + 'solicitudes/tarjetas/debito',
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + AuthService.getCurrentToken(),
    },
  };

  return await axios(config);
}
export async function getSucursales() {
  var config = {
    method: "get",
    url: consultasAPI + 'sucursales/obtenerSucursales',
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + AuthService.getCurrentToken(),
    },
  };

  return await axios(config);
}

export async function generarTarjetaDebito(datosSolicitud) {
  var data = JSON.stringify({
    ...datosSolicitud,
    operador: "900059",
  });

  var config = {
    method: "post",
    url: solicitudes + "solicitudes/tarjetas/generar-tarjeta-debito",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + AuthService.getCurrentToken(),
    },
    data: data,
  };

  return await axios(config);
}
